/**
 * 国际化配置文件
 * ch:中文
 * en:英文
 */
 export default {
    error: { SC:"错误", TC: "錯誤", EN: "Error" }
    ,information: { SC:"提示", TC: "提示", EN: "Information" }
    ,warning: { SC:"警告", TC: "警告", EN: "Warning" }
}